import React, {Component} from "react";
import {Divider, Dropdown, Icon, Modal, Menu} from "antd";
import {path, equals, assoc, isEmpty} from "ramda";
import Layout from "../components/layout/Layout";
import {connect} from "react-redux";
import I18n from "../i18n";
import OrganizationActions from "../reducers/OrganizationReducer";
import ContentBox from "../components/layout/ContentBox";
import CUEmployeesModal from "../components/modal/CUEmployees";
import EmployeeAttrModal from "../components/modal/EmployeeAttr";
import DeleteEmployeesModal from "../components/modal/DeleteEmployees";
import SeeHistoryEmployeesModal from "../components/modal/SeeHistoryEmployees";
import EmployeesUtil from "../util/employees";
import ModalUtil from "../util/modal";
import EmployeeTable from "../components/table/EmployeeTable";
import AccountInformation from "../components/account/AccountInformation";
import {
	addEmployee, editEmployee, deleteEmployee,
	addOrganizationCategoryChoice, editOrganizationCategoryChoice,
	importEmployees, deleteOrganizationCategory,
	sendInviteToEmployees, sendStressTestInvite,
	sendInviteToAllEmployees, sendStressTestInviteToAll,
	sendStressTestInviteToRegistered, sendStressTestInviteToNotRegistered,
	deleteMutiEmployee, disableEmployee, disableMutiEmployee,
	getEmployees
} from "../actions/OrganizationAction";
import AdminSettingPanel from "../containers/AccountPanels/AdminSettingPanel";
import {isAlive} from "../util";
import {ContainerLoading} from "../components/loading/PersistGateLoading";
import UserUtil from "../util/user";
import {
	DropdownMenu,
	DropdownMenuIem,
	DropdownSubMenu,
	DropdownButtonPlaceholer,
	SubMenuPlaceholder,
} from "../components/button/Dropdown";
import {OButtonText} from "../components/text/OText";
import EmployeeImportModeModal from "../components/modal/EmployeeImportModeModal";

const EmailSendType = {
	SELECT: "select",
	ALL: "all",
	REGISTERED: "registered",
	NOT_REGISTERED: "not_registered",
};

class Account extends Component {
    state = {
    	// data: this.props.employees || [],
    	selectedRows: [],
    	isLoading: false,
    	active_employees: 0,
    	registered_user: 0,
    	employeeImportMode: "add_new",
    }
    texts = {};

    constructor(props) {
    	super(props);
    	this.texts = {
    		test_invitation_title: I18n.t("send_test_invitation_email"),
    		send_invite_title: I18n.t("send_invitation_email"),
    		stress_test_title: I18n.t("stress_test"),
    		stress_test_select: I18n.t("send_email_select"),
    		stress_test_all: I18n.t("send_email_all"),
    		stress_test_all_registered: I18n.t("send_email_registered"),
    		stress_test_not_registered: I18n.t("send_email_not_registered"),
    		send_invite_to_select: I18n.t("send_email_select"),
    		send_invite_to_all: I18n.t("send_email_all"),
    		send_email_all_ask: I18n.t("send_email_all_ask"),
    		send_email_require: I18n.t("send_email_require"),
    		select_some_email_warning: I18n.t("select_some_email_warning"),
    		yesText: I18n.t("yes"),
    		noText: I18n.t("no"),
    	};
    }

    componentDidMount() {
    	const {getAllAdmins, fetchLogs} = this.props;
    	// this.getEmp()
    	getAllAdmins();
    	fetchLogs();
    	this.getRegisteredEmp().then(res => {
    		const {pagination} = res;
    		if (pagination) {
    			const {total} = pagination;
    			this.setRegisteredUserLength(total);
    		}
    	});
    }

    setSelectedRows = (selectedRows) => this.setState({selectedRows})
    setActiveEmployeeLength = (active_employees) => this.setState({active_employees})
    setRegisteredUserLength = (registered_user) => this.setState({registered_user})
    getEmp = () => this.refs.employee_table.getEmp()

    getRegisteredEmp() {
    	const packRequest = {have_user: true, page: 1, per_page: 10};
    	return getEmployees(packRequest);
    }

    getActiveEmp = (options) => {
    	const {search = "", page = 1, per_page = 10} = options || {};
    	let packRequest = {...options, have_user: true, active: "active", page, per_page};
    	if (search.trim() !== "") {
    		packRequest = {...packRequest, search};
    	}
    	return getEmployees(packRequest);
    };

    EmpCallback = (callback) => {
    	const {total = 0} = callback;
    	this.setRegisteredUserLength(total);
    }

    onSubmitSearch = (results) => this.setState({data: results})
    onSubmitAddEmployee = (payload) => new Promise(resolve => addEmployee(payload).then(res => {
    	this.getEmp();
    	resolve(res);
    }))
    onSubmitEditEmployee = (payload) => new Promise(resolve => editEmployee(payload).then(res => {
    	this.getEmp();
    	resolve(res);
    }))
    onSubmitDeleteEmployee = (payload) => new Promise(resolve => {
    	this.setState({selectedRows: []});
    	if (payload.employee_ids) deleteMutiEmployee(payload).then(() => {
    		this.getEmp();
    		resolve();
    	});
    	else deleteEmployee(payload).then(() => {
    		this.getEmp();
    		resolve();
    	});
    })
    onDisableEmployee = (payload) => new Promise(resolve => {
    	if (payload.employee_ids) disableMutiEmployee(payload).then(() => {
    		this.getEmp();
    		resolve();
    	});
    	else disableEmployee(payload).then(() => {
    		this.getEmp();
    		resolve();
    	});
    })
    onSubmitManageAttr = ({payload, id}) => new Promise(resolve => {
    	if (payload.new_choices)
    		editOrganizationCategoryChoice({payload, id}).then(() => resolve());
    	else
    		addOrganizationCategoryChoice({payload, id}).then(() => resolve());
    })
    onSubmitDeleteAttr = (id) => new Promise(resolve => deleteOrganizationCategory(id).then((res) => resolve(res)))

    showEmailLanguageSelection(onConfirm) {
    	ModalUtil.showLanguageSelection({
    		title: I18n.t("send_email_language_ask_title"),
    		message: I18n.t("send_email_language_ask_message"),
    		okText: I18n.t("send"),
    		cancel: I18n.t("cancel"),
    		onOk: onConfirm,
    	});
    }

    onSubmitEmployeeImportMode = (mode) => {
    	this.setState({employeeImportMode: mode});
    	this.refs.import.click();
    }
    sendInvitationEmailByType = (type = EmailSendType.SELECT) => {
    	// console.log('sendInvitationEmailByType: ',type);
    	switch (type) {
    	case EmailSendType.SELECT:
    		const {selectedRows} = this.state;
    		if (isAlive(selectedRows) && selectedRows.length > 0) {
    			this.showEmailLanguageSelection((lang) => {
    				console.log("showEmailLanguageSelection callback: lang");
    				this.onLoading();
    				const employee_ids = Array.from(selectedRows, v => v.id);
    				sendInviteToEmployees(employee_ids, lang).then(res => {
    					this.onLoaded();
    				}).catch(error => {
    					this.onLoaded();
    				});
    			});
    		} else {
    			ModalUtil.showWarning({
    				title: this.texts.send_email_require,
    				message: this.texts.select_some_email_warning
    			});
    		}
    		break;
    	case EmailSendType.ALL:
    		Modal.confirm({
    			title: this.texts.test_invitation_title,
    			content: this.texts.send_email_all_ask,
    			okText: this.texts.yesText,
    			cancelText: this.texts.noText,
    			onOk: () => {
    				this.showEmailLanguageSelection((lang) => {
    					this.onLoading();
    					sendInviteToAllEmployees(lang).then(res => {
    						this.onLoaded();
    					}).catch(error => {
    						this.onLoaded();
    					});
    				});
    			}
    		});
    		break;
    	default:
    		console.log(`Wrong send type as ${type}`);
    		break;
    	}
    }
    sendStressInviteByType = (type = EmailSendType.SELECT) => {
    	// console.log('sendStressInviteOf type = ',type);
    	switch (type) {
    	case EmailSendType.SELECT:
    		const {selectedRows} = this.state;
    		if (isAlive(selectedRows) && selectedRows.length > 0) {
    			this.showEmailLanguageSelection((lang) => {
    				this.onLoading();
    				const employee_ids = Array.from(selectedRows, v => v.id);
    				sendStressTestInvite(employee_ids,lang).then(res => {
    					this.onLoaded();
    				}).catch(error => {
    					this.onLoaded();
    				});
    			});
    		} else {
    			ModalUtil.showWarning({
    				title: this.texts.send_email_require,
    				message: this.texts.select_some_email_warning
    			});
    		}
    		break;
    	case EmailSendType.ALL:
    		// console.warn('Send stress test invite is not working yet, require api.');
    		Modal.confirm({
    			title: this.texts.test_invitation_title,
    			content: this.texts.send_email_all_ask,
    			okText: this.texts.yesText,
    			cancelText: this.texts.noText,
    			onOk: () => {
    				this.showEmailLanguageSelection((lang) => {
    					this.onLoading();
    					sendStressTestInviteToAll(lang).then(res => {
    						this.onLoaded();
    					}).catch(error => {
    						this.onLoaded();
    					});
    				});
    			},
    		});
    		break;
    	case EmailSendType.REGISTERED:
    		// console.warn('Send stress test invite is not working yet, require api.');
    		Modal.confirm({
    			title: this.texts.test_invitation_title,
    			content: this.texts.send_email_all_ask,
    			okText: this.texts.yesText,
    			cancelText: this.texts.noText,
    			onOk: () => {
    				this.showEmailLanguageSelection((lang) => {
    					this.onLoading();
    					sendStressTestInviteToRegistered(lang).then(res => {
    						this.onLoaded();
    					}).catch(error => {
    						this.onLoaded();
    					});
    				});
    			},
    		});
    		break;
    	case EmailSendType.NOT_REGISTERED:
    		// console.warn('Send stress test invite is not working yet, require api.');
    		Modal.confirm({
    			title: this.texts.test_invitation_title,
    			content: this.texts.send_email_all_ask,
    			okText: this.texts.yesText,
    			cancelText: this.texts.noText,
    			onOk: () => {
    				this.showEmailLanguageSelection((lang) => {
    					this.onLoading();
    					sendStressTestInviteToNotRegistered(lang).then(res => {
    						this.onLoaded();
    					}).catch(error => {
    						this.onLoaded();
    					});
    				});
    			},
    		});
    		break;
    	default:
    		console.warn(`Wrong send type as ${type}`);
    		break;
    	}
    }

    onLoading() {
    	this.setState({isLoading: true});
    }

    onLoaded() {
    	this.setState({isLoading: false});
    }

    renderStressDropdown() {
    	return (<Dropdown overlay={
    		<Menu onClick={(e) => {
    			this.sendStressInviteByType(e.keyPath[0]);
    		}} mode="vertical">
    			<DropdownSubMenu key={"sub_stress"} title={<p>{this.texts.stress_test_title}</p>}
    			>
    				<DropdownMenuIem key={EmailSendType.SELECT}>
    					{this.texts.stress_test_select}
    				</DropdownMenuIem>
    				<DropdownMenuIem key={EmailSendType.ALL}>
    					{this.texts.stress_test_all}
    				</DropdownMenuIem>
    				<DropdownMenuIem key={EmailSendType.REGISTERED}>
    					{this.texts.stress_test_all_registered}
    				</DropdownMenuIem>
    				<DropdownMenuIem key={EmailSendType.NOT_REGISTERED}>
    					{this.texts.stress_test_not_registered}
    				</DropdownMenuIem>
    			</DropdownSubMenu>
    		</Menu>
    	}>
    		<DropdownButtonPlaceholer>
    			{this.texts.test_invitation_title} <Icon type="down"/>
    		</DropdownButtonPlaceholer>
    	</Dropdown>);
    }

    renderInviteDropdown() {
    	return (<Dropdown overlay={<Menu onClick={(e) => {
    		this.sendInvitationEmailByType(e.keyPath[0]);
    	}}>
    		<DropdownMenuIem key={EmailSendType.SELECT}>{this.texts.send_invite_to_select}</DropdownMenuIem>
    		<DropdownMenuIem key={EmailSendType.ALL}>{this.texts.send_invite_to_all}</DropdownMenuIem>
    	</Menu>
    	}>
    		<DropdownButtonPlaceholer>
    			{this.texts.send_invite_title} <Icon type="down"/>
    		</DropdownButtonPlaceholer>
    	</Dropdown>);
    }

    render() {
    	const {admins, category_title, organizationLoading, logs, choice, user_roles} = this.props;
    	const {active_employees, registered_user} = this.state;
    	const isSuperAdmin = UserUtil.isRole(user_roles, UserUtil.Roles.OrganizationSuperAdmin) || UserUtil.isRole(user_roles, UserUtil.Roles.SuperAdmin);
    	;
    	return <Layout>
    		<AccountInformation logs={logs} active_employees={active_employees} registered_user={registered_user}/>
    		<Divider/>
    		<ContentBox.HeaderToolbar header=""
    			buttonsProps={[{children: this.renderStressDropdown()}, {children: this.renderInviteDropdown()}, {
    				icon: "delete", text: "Delete", size: "large", onClick: () => {
    					const {selectedRows} = this.state;
    					if (selectedRows.length > 0) this.refs.de.showModal(selectedRows);
    				}
    			}, {
    				icon: "user",
    				text: "Create User",
    				size: "large",
    				onClick: () => this.refs.cue.showModal()
    			}, {
    				text: "Import Excel File",
    				size: "large",
    				onClick: () => this.refs.eim.showModal()
    			}]}/>
    		<EmployeeTable ref="employee_table" //callback={this.EmpCallback}
    			choice={choice} category_title={category_title} loading={organizationLoading}
    			setSelectedRows={this.setSelectedRows} setActiveEmployeeLength={this.setActiveEmployeeLength}
    			columns={EmployeesUtil.buildColumnsEmployees(
    				{
    					category_title,
    					choice,
    					onEdit: user => this.refs.cue.showModal(user),
    					onDelete: user => {
    						this.refs.de.showModal(user);
    					},
    					onSeeHistory: user => {
    						this.refs.his.showModal(user);
    					},
    					onManageAttrbiute: (index = null, choice = null) =>
    						this.refs.ea.showModal(index, choice)
    				}
    			)
    				// EmployeesUtil.buildColumnsOverviewEmployees({ category_title })
    			}/>
    		<SeeHistoryEmployeesModal ref="his" choice={choice} category_title={category_title}/>
    		<CUEmployeesModal ref="cue" onSubmitEditEmployee={this.onSubmitEditEmployee}
    			onSubmitAddEmployee={this.onSubmitAddEmployee} choice={choice}/>
    		<DeleteEmployeesModal ref="de" onSubmitDeleteEmployee={this.onSubmitDeleteEmployee}
    			onDisableEmployee={this.onDisableEmployee}/>
    		<EmployeeAttrModal ref="ea" onSubmitManageAttr={this.onSubmitManageAttr}
    			onSubmitDeleteAttr={this.onSubmitDeleteAttr} category_title={category_title}/>
    		<EmployeeImportModeModal ref="eim" onSubmitEmployeeImportMode={this.onSubmitEmployeeImportMode}/>
    		<Divider/>
    		{isSuperAdmin ? <AdminSettingPanel admins={admins} getActiveEmp={this.getActiveEmp}/> : undefined}
    		<input ref="import" type="file" style={{display: "none"}}
    			accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    			onChange={event => importEmployees(event.target.files[0], this.state.employeeImportMode).then(
    				() => {
    					this.refs.import.value = "";
    				}
    			)}/>
    	</Layout>;
    }
}

const mapStateToProps = state => ({
	user_roles: path(["user", "user", "roles"], state),
	// employees: state.organization.employees ? state.organization.employees.map((value, index) => assoc('key', index, value)) : [],
	admins: state.organization.admins ? state.organization.admins.map((value, index) => assoc("key", index, value)) : [],
	logs: state.organization.logs ? state.organization.logs.map((value, index) => assoc("key", index, value)) : [],
	organizationLoading: state.organization.loading,
	category_title: {
		category1_title: state.organization.organization.category1_title,
		category2_title: state.organization.organization.category2_title,
		category3_title: state.organization.organization.category3_title,
		category4_title: state.organization.organization.category4_title
	},
	choice: {
		choice1: state.organization.organization.choice1,
		choice2: state.organization.organization.choice2,
		choice3: state.organization.organization.choice3,
		choice4: state.organization.organization.choice4,
	}
});

const mapStateToDispatch = dispatch => ({
	getAllAdmins: () => dispatch(OrganizationActions.getAllAdminsRequest()),
	fetchLogs: () => dispatch(OrganizationActions.fetchOrganizationLogsRequest())
});

export default connect(mapStateToProps, mapStateToDispatch)(Account);




// WEBPACK FOOTER //
// ./src/containers/Account.js